import axios from 'lib/axios'

export const getProductToursApi = async (key) => {
  try {
    const response = await axios.get(`/api/product_tours/${key}`)
    return response.data
  } catch (error) {
    throw new Error(error)
  }
}

export const markBeaconAsShownApi = async (key) => {
  try {
    const response = await axios.post(`/api/product_tours/${key}/shown`)
    return response.data
  } catch (error) {
    throw new Error(error)
  }
}

export const hideBeaconApi = async (key, value) => {
  try {
    const response = await axios.post(`/api/product_tours/${key}/set_visibility`, {
      should_hidden: value,
    })
    return response.data
  } catch (error) {
    throw new Error(error)
  }
}
